import React, { useState, useContext, useEffect, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { useSearchParams } from "react-router-dom";
import { useFilters, useGlobalFilter, usePagination, useSortBy, useTable } from "react-table";
import Cookies from "js-cookie";

import errorToast from "helpers/errorToast";
import { getQuotingPerformanceAnalytics } from "api";
import DataTable from "components/organisms/DataTable/DataTable";
import AnalyticsContext from "../analyticsContext";

function OnTimePerformance() {
  const { params } = useContext(AnalyticsContext);

  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [searchParams] = useSearchParams();
  const queryPage = +(searchParams.get("page") || 0);

  const columns = useMemo(
    () => [
      {
        Header: (
          <span className="pl-9">
            <FormattedMessage id="general.provider" defaultMessage="Provider" />
          </span>
        ),
        accessor: "provider",
        sortable: true,
        // eslint-disable-next-line react/prop-types
        Cell: ({ value }) => <p className="pl-9 pt-8 pb-8 mb-0">{value}</p>,
      },
      {
        Header: (
          <span className="mb-0 text-right">
            <FormattedMessage id="quote-request.invitedToQuote" defaultMessage="Invited To Quote" />
          </span>
        ),
        accessor: "invited",
        sortable: true,
        // eslint-disable-next-line react/prop-types
        Cell: ({ value }) => <p className="pt-8 pb-8 mb-0">{value}</p>,
      },
      {
        Header: (
          <span className="mb-0">
            <FormattedMessage id="general.quoted" defaultMessage="Quoted" />
          </span>
        ),
        accessor: "quoted",
        sortable: true,
        // eslint-disable-next-line react/prop-types
        Cell: ({ value }) => <div className="pt-8 pb-8">{value}</div>,
      },
      {
        Header: (
          <span className="mb-0 text-right">
            <FormattedMessage id="general.notQuoted" defaultMessage="Not Quoted" />
          </span>
        ),
        accessor: "not_quoted",
        sortable: true,
        // eslint-disable-next-line react/prop-types
        Cell: ({ value }) => <div className={`pt-8 pb-8 `}>{value}</div>,
      },
      {
        Header: (
          <span className="mb-0 text-right">
            <FormattedMessage id="shipment-quotes.components.invitedProviders.won" defaultMessage="Won" />
          </span>
        ),
        accessor: "won",
        sortable: true,
        // eslint-disable-next-line react/prop-types
        Cell: ({ value }) => <div className={`pt-8 pb-8 `}>{value}</div>,
      },
      {
        Header: (
          <span className="mb-0 text-right">
            <FormattedMessage id="shipment-quotes.components.invitedProviders.lost" defaultMessage="Lost" />
          </span>
        ),
        accessor: "lost",
        sortable: true,
        // eslint-disable-next-line react/prop-types
        Cell: ({ value }) => <div className={`pt-8 pb-8 `}>{value}</div>,
      },
      {
        Header: (
          <span className="mb-0 text-right">
            <FormattedMessage id="shipment-quotes.components.invitedProviders.declined" defaultMessage="Declined" />
          </span>
        ),
        accessor: "declined",
        sortable: true,
        // eslint-disable-next-line react/prop-types
        Cell: ({ value }) => <div className={`pt-8 pb-8 `}>{value}</div>,
      },
    ],
    [],
  );

  const instance = useTable(
    {
      initialState: {
        pageSize: +(Cookies.get("listing_sizeperpage") || 10),
        pageIndex: queryPage ? queryPage - 1 : 0,
      },
      columns,
      data,
      manualPagination: true,
      pageCount: Math.ceil(totalData / +(Cookies.get("listing_sizeperpage") || 10)),
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
  );

  const getData = () => {
    setIsLoading(true);
    getQuotingPerformanceAnalytics({
      params: {
        page_size: instance.state.pageSize,
        page: instance.state.pageIndex + 1,
        ...params,
      },
    })
      .then((res) => {
        setData(res.data.results);
        setTotalData(res.data.count);
        setIsLoading(false);
      })
      .catch((err) => errorToast(err));
  };

  useEffect(() => getData(), [params, instance.state.pageSize, instance.state.pageIndex]);

  useEffect(() => {
    instance.gotoPage(queryPage ? queryPage - 1 : 0);
  }, [queryPage]);

  if (isLoading)
    return (
      <div className="text-center d-flex align-items-center justify-content-center" style={{ height: "400px" }}>
        <div className="spinner-border text-primary" role="status" />
      </div>
    );

  return (
    <div className="mt-3">
      <DataTable tableInstance={instance} totalData={totalData} isLoading={isLoading} draggable={false} />
    </div>
  );
}

export default OnTimePerformance;
